import * as React from 'react';
import { Row } from 'react-bootstrap';
import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow, toUpper } from 'lodash';
import { connect } from 'react-redux';
import ResetPasswordForm from './components/ResetPasswordForm';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import {IStore} from '../../../../redux/IStore';

interface IAuthError {
  detail: string;
}

interface IResetPasswordProps {
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  title: string;
  message: string;
  auth: {
    error: {
      reset: {
        error: IAuthError,
      },
      update: {
        error: IAuthError,
      },
    },
  };
  match: {
    params: {
      token: string,
    },
  };
}

interface IResetPasswordState {
  hasPasswordBeenReset: boolean;
}

class ResetPassword extends React.Component<IResetPasswordProps, IResetPasswordState> {
  public state = {
    hasPasswordBeenReset: false,
  };

  private handleSubmit = (values) => {
    const { actions, match } = this.props;
    const token = match.params.token;
    actions.auth.resetPassword(token, values);
  }

  public render() {
    const { title, auth } = this.props;

    return (
      <Row className="page-container animated fadeIn">
        <div className="customer-section-title">
          <h1>{title ? title : 'Reset your password'}</h1>
        </div>
        <ResetPasswordForm auth={auth} onSubmit={this.handleSubmit} buttonText={toUpper(title)}/>
        {/*{auth.error && (*/}
          {/*<div>*/}
            {/*{map(auth.error.reset, (error: IAuthError, key) => {*/}
              {/*return <p key={key}>{translatePasswordError(error.detail)}</p>;*/}
            {/*})}*/}
          {/*</div>*/}
        {/*)}*/}
      </Row>
    );
  }
}

// let selector;

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  // (component) => {
  //   selector = formValueSelector('reset_password');
  //
  //   return component;
  // },
  connect(
    (state: IStore) => ({
      auth: state.auth,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(ResetPassword);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ResetPassword/index.tsx